var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.to)?_c('a',{staticClass:"base-btn transition",class:_vm.classes,attrs:{"href":_vm.to},on:{"click":_vm.sendGaEvent}},[_vm._t("default")],2):_c('button',{staticClass:"base-btn transition",class:_vm.classes,attrs:{"type":"button"},on:{"click":_vm.sendGaEvent}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }